import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/crm/report/expense";

/**
 * 费用统计（报表）接口
 */
export default {
    /** 查询费用统计报表，支持按费用类型/人员/部门三个维度 */
    report: (data) => axios.get({url: `${PREFIX_URI}/report`, data}),
}
